import { solveCircularAlphaZero } from "./alphaZero";

/**
 * Location-dependent alerts become available once the data point is entered:
 * the same alert the output will carry for a trace that runs the whole log,
 * or for a level plane in an inclined tunnel.
 */
export function circularInputAlerts(dim) {
  const exactOr = (v, fallback) => (v === "" || v === null || v === undefined || !isFinite(Number(v)) ? fallback : Number(v));
  const Dir = Number(dim.dir) % 360;
  const amt = Number(dim.amt);
  const result = solveCircularAlphaZero({
    D: Number(dim.direction) % 360,
    Dir,
    amt,
    DirExact: exactOr(dim.dirExact, Dir),
    amtExact: exactOr(dim.amtExact, amt),
    I: Number(dim.inclination) || 0,
    R: Number(dim.radiusofcrown),
    dimension: dim,
  });
  return result && result.alert ? [result.alert] : [];
}
